// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  background-color: #000000;
  font-family: "Open Sans", sans serif;
  font-weight: 300;
  -webkit-tap-highlight-color: transparent;
}

.keypad-wrapper {
  text-align: center;
  width: 100%;
  color: #FFFFFF;
}
.keypad-wrapper .input-wrapper {
  margin: 30px 0;
  line-height: 32px;
  vertical-align: middle;
}
.keypad-wrapper .input-wrapper .number-input {
  display: inline-block;
  height: 15px;
  width: 15px;
  border-radius: 50px;
  border: 1px solid #FFFFFF;
  margin-right: 2%;
  margin-left: 2%;
  font-size: 2em;
}
.keypad-wrapper .actions {
  width: 100%;
  margin: auto;
  text-align: center;
  padding: 30px 0;
}
.keypad-wrapper .actions button {
  border-radius: 25px;
  border: 1px solid white;
  font-size: 24px;
  cursor: pointer;
  margin: 0 20px;
  padding: 5px 10px;
  background: white;
}
.keypad-wrapper .actions button:hover {
  background: black;
  color: white;
  border: 1px solid white;
}
.keypad-wrapper .actions button:disabled {
  color: gray;
}
.keypad-wrapper .actions button:disabled:hover {
  background: white;
  border: 1px solid white;
  color: gray;
}
.keypad-wrapper .keypad {
  padding: 30px 0;
}
.keypad-wrapper .keypad .number-line {
  width: 100%;
  padding-bottom: 30px;
}
.keypad-wrapper .keypad .keypad-number {
  display: inline-block;
  margin: 0 8%;
}
.keypad-wrapper .keypad .keypad-number div {
  width: 64px;
  height: 64px;
  text-align: center;
  border: 1px solid #FFFFFF;
  border-radius: 70px;
  display: inline-block;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
.keypad-wrapper .keypad .keypad-number div .number {
  display: block;
  font-size: 32px;
  margin: 10%;
  vertical-align: middle;
}
.keypad-wrapper .keypad .keypad-number div:hover {
  background-color: #ffffff;
  color: #000000;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.no-circle {
  width: auto !important;
  border: none !important;
  height: auto !important;
}

@media screen and (max-width: 385px) {
  .keypad-number {
    margin: 0 2% !important;
  }
  .actions button {
    margin: 0 10px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,UAAA;EACA,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,wCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AAAF;AAEE;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;AAAJ;AAEI;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAAN;AAIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAFJ;AAII;EACE,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAFN;AAIM;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;AAFR;AAKM;EACE,WAAA;AAHR;AAKQ;EACE,iBAAA;EACA,uBAAA;EACA,WAAA;AAHV;AASE;EACE,eAAA;AAPJ;AASI;EACE,WAAA;EACA,oBAAA;AAPN;AAUI;EACE,qBAAA;EACA,YAAA;AARN;AAUM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EAGA,iBAAA;AARR;AAUQ;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AARV;AAYM;EACE,yBAAA;EACA,cAAA;EACA,2BAAA;EACA,yBAAA;EAGA,iBAAA;AAVR;;AAgBA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AAbF;;AAgBA;EACE;IACE,uBAAA;EAbF;EAiBE;IACE,yBAAA;EAfJ;AACF","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Open+Sans:300);\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  background-color: #000000;\n  font-family: 'Open Sans', sans serif;\n  font-weight: 300;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.keypad-wrapper {\n  text-align: center;\n  width: 100%;\n  color: #FFFFFF;\n\n  .input-wrapper {\n    margin: 30px 0;\n    line-height: 32px;\n    vertical-align: middle;\n\n    .number-input {\n      display: inline-block;\n      height: 15px;\n      width: 15px;\n      border-radius: 50px;\n      border: 1px solid #FFFFFF;\n      margin-right: 2%;\n      margin-left: 2%;\n      font-size: 2em;\n    }\n  }\n\n  .actions {\n    width: 100%;\n    margin: auto;\n    text-align: center;\n    padding: 30px 0;\n\n    button {\n      border-radius: 25px;\n      border: 1px solid white;\n      font-size: 24px;\n      cursor: pointer;\n      margin: 0 20px;\n      padding: 5px 10px;\n      background: white;\n\n      &:hover {\n        background: black;\n        color: white;\n        border: 1px solid white;\n      }\n\n      &:disabled {\n        color: gray;\n\n        &:hover {\n          background: white;\n          border: 1px solid white;\n          color: gray;\n        }\n      }\n    }\n  }\n\n  .keypad {\n    padding: 30px 0;\n\n    .number-line {\n      width: 100%;\n      padding-bottom: 30px;\n    }\n\n    .keypad-number {\n      display: inline-block;\n      margin: 0 8%;\n\n      div {\n        width: 64px;\n        height: 64px;\n        text-align: center;\n        border: 1px solid #FFFFFF;\n        border-radius: 70px;\n        display: inline-block;\n        cursor: pointer;\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n\n        .number {\n          display: block;\n          font-size: 32px;\n          margin: 10%;\n          vertical-align: middle;\n        }\n      }\n\n      div:hover {\n        background-color: #ffffff;\n        color: #000000;\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n      }\n    }\n  }\n}\n\n.no-circle {\n  width: auto !important;\n  border: none !important;\n  height: auto !important;\n}\n\n@media screen and (max-width: 385px) {\n  .keypad-number {\n    margin: 0 2% !important;\n  }\n\n  .actions {\n    button {\n      margin: 0 10px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
